"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GestureAnimation = void 0;

var react_1 = __importStar(require("react"));

var components_utils_1 = require("@conte-ltd/components-utils");

var animation_1 = require("./animation");

var use_animation_controller_1 = require("./use-animation-controller");

var react_use_gesture_1 = require("react-use-gesture");

function _GestureAnimation(props, fwRef) {
  var children = props.children,
      _onDrag = props.onDrag,
      _onDragStart = props.onDragStart,
      _onDragEnd = props.onDragEnd,
      _onPinch = props.onPinch,
      _onPinchStart = props.onPinchStart,
      _onPinchEnd = props.onPinchEnd,
      _onWheel = props.onWheel,
      _onWheelStart = props.onWheelStart,
      _onWheelEnd = props.onWheelEnd,
      _onMove = props.onMove,
      _onMoveStart = props.onMoveStart,
      _onMoveEnd = props.onMoveEnd,
      _onScroll = props.onScroll,
      _onScrollStart = props.onScrollStart,
      _onScrollEnd = props.onScrollEnd,
      _onHover = props.onHover,
      config = props.config,
      other = __rest(props, ["children", "onDrag", "onDragStart", "onDragEnd", "onPinch", "onPinchStart", "onPinchEnd", "onWheel", "onWheelStart", "onWheelEnd", "onMove", "onMoveStart", "onMoveEnd", "onScroll", "onScrollStart", "onScrollEnd", "onHover", "config"]);

  var _a = (0, use_animation_controller_1.useAnimationController)(),
      animationRef = _a.ref,
      play = _a.play,
      pause = _a.pause,
      reverse = _a.reverse,
      animationCancel = _a.cancel,
      finish = _a.finish,
      seek = _a.seek,
      animate = _a.animate,
      getId = _a.getId,
      getPlayState = _a.getPlayState,
      getContext = _a.getContext,
      updatePlaybackRate = _a.updatePlaybackRate;

  var bind = (0, react_use_gesture_1.useGesture)({
    onDrag: function onDrag(state) {
      return _onDrag === null || _onDrag === void 0 ? void 0 : _onDrag(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onDragStart: function onDragStart(state) {
      return _onDragStart === null || _onDragStart === void 0 ? void 0 : _onDragStart(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onDragEnd: function onDragEnd(state) {
      return _onDragEnd === null || _onDragEnd === void 0 ? void 0 : _onDragEnd(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onPinch: function onPinch(state) {
      return _onPinch === null || _onPinch === void 0 ? void 0 : _onPinch(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onPinchStart: function onPinchStart(state) {
      return _onPinchStart === null || _onPinchStart === void 0 ? void 0 : _onPinchStart(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onPinchEnd: function onPinchEnd(state) {
      return _onPinchEnd === null || _onPinchEnd === void 0 ? void 0 : _onPinchEnd(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onWheel: function onWheel(state) {
      return _onWheel === null || _onWheel === void 0 ? void 0 : _onWheel(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onWheelStart: function onWheelStart(state) {
      return _onWheelStart === null || _onWheelStart === void 0 ? void 0 : _onWheelStart(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onWheelEnd: function onWheelEnd(state) {
      return _onWheelEnd === null || _onWheelEnd === void 0 ? void 0 : _onWheelEnd(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onMove: function onMove(state) {
      return _onMove === null || _onMove === void 0 ? void 0 : _onMove(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onMoveStart: function onMoveStart(state) {
      return _onMoveStart === null || _onMoveStart === void 0 ? void 0 : _onMoveStart(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onMoveEnd: function onMoveEnd(state) {
      return _onMoveEnd === null || _onMoveEnd === void 0 ? void 0 : _onMoveEnd(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onScroll: function onScroll(state) {
      return _onScroll === null || _onScroll === void 0 ? void 0 : _onScroll(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onScrollStart: function onScrollStart(state) {
      return _onScrollStart === null || _onScrollStart === void 0 ? void 0 : _onScrollStart(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onScrollEnd: function onScrollEnd(state) {
      return _onScrollEnd === null || _onScrollEnd === void 0 ? void 0 : _onScrollEnd(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    },
    onHover: function onHover(state) {
      return _onHover === null || _onHover === void 0 ? void 0 : _onHover(__assign(__assign({}, state), {
        play: play,
        pause: pause,
        reverse: reverse,
        animationCancel: animationCancel,
        finish: finish,
        seek: seek,
        animate: animate,
        getId: getId,
        getPlayState: getPlayState,
        getContext: getContext,
        updatePlaybackRate: updatePlaybackRate
      }));
    }
  }, config);
  return react_1.default.createElement(animation_1.Animation, __assign({}, other, {
    ref: (0, components_utils_1.mergeRefs)([fwRef, animationRef])
  }), function (_a) {
    var ref = _a.ref;
    return (0, components_utils_1.runIfFunction)(children, __assign(__assign({}, bind()), {
      ref: ref
    }));
  });
}

exports.GestureAnimation = (0, react_1.forwardRef)(_GestureAnimation);